import CargoDamaged from "@/components/icons/cargo-damaged";
import InvoicePrint from "@/components/icons/invoice-print";
import MagnifyingGlassIconColor from "@/components/icons/magnifying-glass-color";
import RefundIcon from "@/components/icons/refund";
import ShipWithContainer from "@/components/icons/ship-with-container";
import TransactionIcon from "@/components/icons/transactions";
import TurtleIcon from "@/components/icons/turtle";
import { Client, Order, OrderStatus } from "@/types";
import SimpleBar from "@/ui/simplebar";
import cn from "@/utils/class-names";
import { avatarIds } from "@/utils/get-avatar";
import { getRandomArrayElement } from "@/utils/get-random-array-element";
import { toCurrency } from "@/utils/to-currency";
import { PiEnvelopeSimple, PiMoney, PiPhone, PiStarFill } from "react-icons/pi";
import { Link } from "react-router-dom";
import { Badge, Button, Text, Title } from "rizzui";

interface SidebarProps {
    orders: Order[];
    client: Client;
    className?: string;
}

export default function UserInfo({ client, orders, className }: SidebarProps) {
    const stats = [
        // {
        //     icon: TransactionIcon,
        //     label: "Transactions",
        //     value: orders
        //         .filter((order) => order.status === OrderStatus.Delivered)
        //         .reduce((acc, order) => acc + order.totalPrice, 0),
        //     isCurrency: true,
        // },
        {
            icon: InvoicePrint,
            label: "Invoiced Amount",
            value: orders
                .filter((order) => order.status === OrderStatus.Delivered)
                .reduce((acc, order) => acc + order.totalPrice, 0),
            isCurrency: true,
        },
        {
            icon: RefundIcon,
            label: "Paid Amount",
            value: orders
                .filter((order) => order.status === OrderStatus.Delivered)
                .reduce((acc, order) => acc + order.totalPrice, 0),
            isCurrency: true,
        },
        { icon: ShipWithContainer, label: "Orders", value: orders
          .filter((order) => order.status === OrderStatus.InTransit || order.status === OrderStatus.Delivered)?.length },
        { icon: CargoDamaged, label: "Not Completed", value: orders
          .filter((order) => order.status === OrderStatus.InTransit || order.status !== OrderStatus.Delivered)?.length },
        { icon: TurtleIcon, label: "Delivered", value: orders
          .filter((order) => order.status === OrderStatus.Delivered)?.length },
    ];

    return (
        <article className={cn("lg:px-0 lg:pb-0", className)}>
            <div className="grid items-end gap-4 @xl:grid-cols-[80px_1fr] @2xl:grid-cols-[128px_1fr] md:gap-6">
                <figure className="relative -mt-8 h-20 w-20 rounded-full border-4 border-white drop-shadow @2xl:-mt-12 @2xl:h-32 @2xl:w-32 @4xl:-mt-12 @7xl:-mt-14 bg-primary">
                    <span className="absolute bottom-1.5 right-1.5 z-10 h-3 w-3 rounded-full border-2 border-white bg-[#11A849] @2xl:bottom-2.5 @2xl:right-2.5 @3xl:h-4 @3xl:w-4 @4xl:bottom-2 @4xl:right-2" />
                    
                </figure>
                <div className="grid grid-cols-2 gap-1 md:gap-1">
                    <article>
                        <div className="flex items-center gap-2.5">
                            <Title as="h3" className="text-lg xl:text-xl">
                                {client?.fullname}
                            </Title>
                            <Badge className="gap-1.5 P-3" variant="flat" size="sm">
                                <PiPhone className="h-4 w-4" color="black" />
                               <span color="black">{client?.mobile}</span> 
                            </Badge>
                        </div>
                        <p>
                            <Link to={`mailto:${client?.email}`}>
                                {client?.email}
                            </Link>
                        </p>
                    </article>
                </div>
            </div>

            <SimpleBar>
                <div className="mt-8 grid min-w-[1536px] grid-cols-6 gap-5 rounded-lg border border-muted p-8 md:mt-12">
                    {stats.map((stat, index) => (
                        <div key={index} className="flex items-center gap-3">
                            <div className="flex items-center justify-center">
                                <stat.icon className="h-10 w-10" />
                            </div>
                            <div className="">
                                <Text
                                    fontWeight="medium"
                                    className="block font-lexend text-base text-gray-900"
                                >
                                    {stat.isCurrency
                                        ? toCurrency(stat.value)
                                        : stat.value}
                                </Text>
                                <Text>{stat.label}</Text>
                            </div>
                        </div>
                    ))}
                </div>
            </SimpleBar>
        </article>
    );
}
